import Vue from "vue";
import { VueSkeletonKey } from "@rocketbase/vue-skeleton-key";

Vue.use(VueSkeletonKey, {
  storageKey: "coolfood.fabian-kohler.de",
  url: process.env.VUE_APP_COMMONS_AUTH_URL!,
  domains: [process.env.VUE_APP_INTERCEPTOR_DOMAIN!],
  intercept: true
});

export const auth = Vue.prototype.$auth;
